module.exports=function(data){
    if(data&&data.length>0){
        return data.map((item)=>{
           return {
            logo:"",
            name: item.title,
            address: item.address,
            night: item.night?true:false,
            gallery: item.gallery?true:false,
            feed: item.feed?true:false,
            controlpanel: item.controlpanel?true:false,
            date: item.createdAt,
           }
        })
    }
}